import { CurrencySelector, ProfileSelectInput } from "@/src/components"
import { LANGUAGES } from "@/src/services"
import { Card, CardContent, CardHeader } from "@mui/material"
import { required, SaveButton, SelectInput, Toolbar } from "react-admin"




export const SectionUserEditSettings = () => {

    return (
        <Card variant="outlined">
            <CardHeader title={"Settings"} />
            <CardContent>
                <SelectInput variant="outlined" source='settings.accountVisibility'
                    label="Account visibility"
                    fullWidth helperText={false} choices={[
                        { id: 'all', name: "To all" },
                        { id: 'registered', name: "To registered users" },
                        { id: 'hidden', name: "Hidden" },
                        { id: 'deactivated', name: "Deactivated" },

                    ]} />
                <SelectInput variant="outlined" source='settings.uiLang'
                    label="UI language"
                    helperText={false} fullWidth
                    choices={LANGUAGES}
                    validate={[required()]}
                />
                <CurrencySelector variant="outlined"
                    source='settings.currency' label="Currency" helperText={false} fullWidth
                    validate={[required()]} />

                <ProfileSelectInput source="settings.notifications.messagesInterval"
                    localePath="notifications:messagesInterval"
                    label="Messages interval notifications"
                    helperText={false}
                    fullWidth
                    validate={[required()]} />
                <ProfileSelectInput source="settings.notifications.visitorsInterval"
                    localePath="notifications:visitorsInterval"
                    label="Visitors interval notifications"
                    helperText={false}
                    fullWidth
                    validate={[required()]} />
            </CardContent>
            <Toolbar
            // {...sanitizeToolbarProps(formProps)}
            >

                <SaveButton label="Save" />
            </Toolbar>
        </Card>
    )
}